import { cloneDeep } from 'lodash'

import {
    DataNavigationMessage,
    DataNavigationState,
    GapsFlowMessage
} from 'plugin-live-exploratory-viz/src/data-navigation/types/widget'
import { onStartQuery } from 'plugin-live-exploratory-viz/src/data-navigation/reducer/start'
import { onSpanQuery } from 'plugin-live-exploratory-viz/src/data-navigation/reducer/span'
import { onEventQuery } from 'plugin-live-exploratory-viz/src/data-navigation/reducer/event'
import { onGapsQuery } from 'plugin-live-exploratory-viz/src/data-navigation/reducer/gaps'

export const shouldDelayClearState = { enabled: false }

export const reducer: WidgetReducerType<DataNavigationState, DataNavigationMessage> = (
    state = getInitialState(),
    message: DataNavigationMessage | GapsFlowMessage
): DataNavigationState => {
    if (!message) {
        return cloneDeep(state)
    }

    switch (message?.type) {
        case 'start':
            return onStartQuery(message, state)
        case 'span':
            return onSpanQuery(message, state)
        case 'event':
            return onEventQuery(message, state)
        case 'gaps':
            return onGapsQuery(message, state)
        default:
            break
    }

    return cloneDeep(state)
}

const getInitialState = (): DataNavigationState => ({
    config: {},
    realtime: false,
    series: {},
    span: [0, Number.MAX_SAFE_INTEGER],
    shouldDelayClearState: shouldDelayClearState
})
